import qs from 'query-string';
import { apiConfig } from '@/services/api-config';

export interface GetAllTerritoriesParams {
  pageSize: number;
  page: number;
}

export const getAllTerritories = (params: GetAllTerritoriesParams) => {
  const userLogged = JSON.parse(sessionStorage.getItem('userLogged') as string);
  const { stKey } = userLogged.company;

  const query = qs.stringify({ ...params, tokenKey: stKey });

  return apiConfig
    .get(`api/territory/get-all?${query}`)
    .then((response) => {
      const { objectResult } = response.data;

      return objectResult;
    })
    .catch(() => []);
};
